export default {
  head: {
    ClientAdmin: 'Merchant Management',
    ClientLIst: 'merchant list'
  },
  table: {
    addClient: 'add merchant',
    agentAccount: 'agent account',
    GeneralAgent: 'general agent',
    merchantModel: 'merchant model',
    merchantName: 'merchant name',
    merchantPhone: 'phone number',
    merchantNo: 'merchanr account',
    merchantResources: 'merchant resource',
    merchantType: 'merchant type',
    merchantStatus: 'merchant status',
    operaTion: 'operate',
    changemessage: 'edit merchant info',
    checkmessage: 'check merchant infomation',
    payon: 'Pay on behalf of',
    equipment: 'equipment',
    merchantEmail: 'merchant email',
    payName: 'Payment name',
    name: 'real name',
    companyNumber: 'Company Number',
    companyPayName: 'Company Name',
    bankBinCode: 'Bank card code',
    bankNumber: 'Bank Account',
    remarks: 'describe',
    ip: 'IP address',
    id: 'id number',
    status: 'state',
    type: 'type',
    autoTransIn: 'automatic transfer',
    prefix: 'Merchant ID prefix',
    domain: 'Pay for a domain name',
    apiDomain: 'api domain name',
    BackDomain: 'Backend domain name',
    ExportProxyIp: 'Export proxy ip'
  },
  typeOption: [
    {
      value: 0,
      label: 'Pay on behalf of'
    },
    {
      value: 1,
      label: 'equipment'
    }
  ],
  statusOption: [
    {
      value: 0,
      label: 'closure'
    },
    {
      value: 1,
      label: 'turn on'
    }
  ],
  addDialog: {
    addmerchant: 'Add merchant',
    userPass: 'Login password',
    payPass: 'Payment Key',
    googleCode: 'Google Key',
    googleQrCode: 'QR Google',
    phone: 'phone number',
    optionModtext1: 'customer pay fee',
    optionModtext2: 'merchant pay fee',
    optionRestext1: 'our provide',
    optionRestext2: 'Merchants provide',
    optionTypetext1: 'General agent',
    optionTypetext2: 'agent',
    optionTypetext3: 'merchant',
    optionWithdratext1: 'Percentage of each withdrawal amount',
    optionWithdratext2: 'Fixed deduction for each transaction',
    placeholdertext: 'Please enter content',
    placeholderName: 'Please enter the merchant name',
    selectModel: 'Choose merchant model',
    selectResour: 'Choose merchant resources',
    selectType: 'Choose merchant type',
    payoutType: 'Merchant payout type',
    normalPayout: 'Normal',
    specialPayout: 'Special',
    orderPrefix: 'Merchant Order Prefix'
  },
  updataDia: {
    updatamerchantModel: 'modify merchant model',
    updatamerchantResources: 'modify merchant resources',
    updatamerchantType: 'modify merchant type',
    updatamerchantWithdrawalType: 'modify withdraw fee',
    wallet: 'wallet type',
    card: 'telcos fee',
    merchantWithdrawalFee: 'withdraw fee value',
    merchantWithdrawalType: ' withdraw fee',
    momo: ' momo fee',
    momoIpay: '  momo business fee',
    onlineBankingDirectConnect: 'Bank transfer fee',
    onlineBankingQr: 'bank qr fee',
    payOnBehalfOf: 'payout fee',
    viettelpay: ' viettelpay fee',
    zalo: ' zalopay fee',
    vipQr: 'QRPro Fee',
    usdt: 'USDT Fee',
    checkName: 'Merchant name cannot be empty！'
  },

  label: {
    card: 'Recharge card fee',
    merchantWithdrawalFee: 'Withdraw fee',
    momo: 'User fee Momo',
    momoIpay: 'Merchant fee Momo',
    onlineBankingDirectConnect: 'Bank transfer fee',
    onlineBankingQr: 'Bank QR fee',
    payOnBehalfOf: 'Payout fee',
    viettelpay: 'Viettel fee',
    zalo: 'ZALO fee',
    usdt: 'USDT fee',
    vipQr: 'QRPro Fee'
  },

  placeholder: {
    card: 'Enter recharge card fee',
    merchantWithdrawalFee: 'Enter withdraw fee',
    momo: 'Enter user fee Momo',
    momoIpay: 'Enter merchant fee Momo',
    onlineBankingDirectConnect: 'Enter online bank fee',
    onlineBankingQr: 'Enter bank QR fee',
    payOnBehalfOf: 'Enter payout fee',
    viettelpay: 'Enter viettel fee',
    zalo: 'Enter ZALO fee',
    usdt: 'Enter USDT fee',
    vipQr: 'Enter QRPro Fee'
  },

  rules: {
    merchantType: {
      required: 'Merchant type must be selected'
    },
    agentAcct: {
      required: 'AgentNo must be selected'
    },
    merchantModel: {
      required: 'Merchant model must be selected'
    },
    merchantResources: {
      required: 'Merchant resources must be selected'
    },
    merchantWithdrawalType: {
      required: 'Merchant withdrawal fee must be selected'
    },
    payPass: {
      required: 'Payment password cannot be empty',
      between: 'Payment password must be greater than 6 digits and less than or equal to 20 digits'
    },
    card: {
      required: 'recharge card fee can not be empty',
      type: 'recharge card fee must be a number',
      min: 'recharge card fee must be greater than 0',
      max: 'The recharge card fee must be less than or equal to 100',

      float: 'recharge card fee can have up to two decimal places'
    },
    merchantWithdrawalFee: {
      required: 'withdrawal fee can not be empty',
      type: 'withdrawal feemust be a number',
      min: 'The required withdrawal fee must be greater than 0',

      max: 'The withdrawal fee must be less than or equal to 100',

      float: 'withdrawal fee can have up to two decimal places'
    },
    momo: {
      required: 'momo personal fee can not be empty',
      type: 'momo personal fee must be a number',
      min: 'momo personal fee must be greater than 0',

      max: 'momo personal fee must be less than or equal to',

      float: 'momo personal fee can have up to two decimal places'
    },
    momoIpay: {
      required: 'Momo merchant fee can not be empty',
      type: 'Momo merchant fee must be a number',
      min: 'Momo merchant fee must be greater than 0',

      max: 'Momo merchant fee must be less than or equal to 100',

      float: 'Momo merchant fee can have up to two decimal places'
    },
    onlineBankingDirectConnect: {
      required: 'Online banking fee can not be empty',
      type: 'Online banking fee must be a number',
      min: 'Online banking fee must be greater than 0',

      max: 'Online banking fee must be less than or equal to 100',

      float: 'Online banking fee can have up to two decimal places'
    },
    onlineBankingQr: {
      required: 'Bank QR can not be empty',
      type: 'Bank QR must be a number',
      min: 'Bank QR must be greater than 0',

      max: 'Bank QR fee must be less than or equal to 100',

      float: 'Bank QR can have up to two decimal places'
    },
    payOnBehalfOf: {
      required: 'payout fee can not be empty',
      type: 'payout fee must be a number',
      min: 'payout fee must be greater than 0',

      max: 'payout fee must be less than or equal to 100',

      float: 'payout fee can have up to two decimal places'
    },
    viettelpay: {
      required: 'viettelpay fee can not be empty',
      type: 'viettelpay fee must be a number',
      min: 'viettelpay fee must be greater than 0',

      max: 'viettelpay fee must be less than or equal to 100',

      float: 'viettelpay fee can have up to two decimal places'
    },
    zalo: {
      required: 'zalo fee can not be empty',
      type: 'zalo fee must be a number',
      min: 'zalo fee must be greater than 0',
      max: 'zalo fee must be less than or equal to 100',
      float: 'zalo fee can have up to two decimal places'
    },
    usdt: {
      required: 'usdt fee can not be empty',
      type: 'usdt fee must be a number',
      min: 'usdt fee must be greater than 0',
      max: 'usdt fee must be less than or equal to 100',
      float: 'usdt fee can have up to two decimal places'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/proxyipmanage.js